// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_ICSS_IMPORT_0___ = require("-!../../../node_modules/css-loader/dist/cjs.js??ref--6-1!../../../node_modules/postcss-loader/src/index.js!../../../node_modules/sass-loader/dist/cjs.js!@css/utils");
var ___CSS_LOADER_GET_URL_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/getUrl.js");
var ___CSS_LOADER_URL_IMPORT_0___ = require("../assets/device-ios.svg");
var ___CSS_LOADER_URL_IMPORT_1___ = require("../assets/device-android.svg");
var ___CSS_LOADER_URL_IMPORT_2___ = require("../assets/device-macos.svg");
var ___CSS_LOADER_URL_IMPORT_3___ = require("../assets/device-windows-desktop.svg");
var ___CSS_LOADER_URL_IMPORT_4___ = require("../assets/device-windows-mobile.svg");
exports = ___CSS_LOADER_API_IMPORT___(false);
exports.i(___CSS_LOADER_ICSS_IMPORT_0___, "", true);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
var ___CSS_LOADER_URL_REPLACEMENT_4___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_4___);
// Module
exports.push([module.id, "._2e8N67kqx{position:relative;width:210px;height:183px;margin-top:37px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_0___ + ")}._6OM77VWMx{width:50px;height:50px;position:absolute;left:14px;top:43px;display:flex;flex-direction:column;align-items:center}._5pny85yNx{margin-top:2px;color:white;width:50px;text-align:center;font-size:8px}._1qZe8FP0x{position:relative;width:208px;height:170px;margin-top:50px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_1___ + ")}._5226wlYLx{width:170px;height:20px;position:absolute;left:17px;top:118px;display:flex;flex-direction:row;justify-content:right}._4w7kyxBfx{overflow:hidden;margin-left:6px}._46J0BXSnx{color:var(--primary-text);font-size:7px}._7lIpxyHJx{color:var(--secondary-text);font-size:7px}._2H23Xd8Ux{position:relative;width:264px;height:183px;margin-top:47px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_2___ + ")}._5GeJdZWQx{width:116px;height:24px;position:absolute;left:121px;top:60px;display:flex;flex-direction:row;justify-content:right}._6TXhMFnTx{overflow:hidden;display:flex;flex-direction:column;justify-content:center;margin-left:6px}._1hRDXjVjx{color:var(--primary-text);font-size:7px}.uqvcJxpAx{color:var(--secondary-text);font-size:7px}._1WwMGZD2x{position:relative;width:264px;height:183px;margin-top:37px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_3___ + ")}._2Ffbn4Atx{width:116px;height:24px;position:absolute;left:121px;top:60px;display:flex;flex-direction:row;justify-content:right}._7b1wpLoQx{overflow:hidden;display:flex;flex-direction:column;justify-content:center;margin-left:6px}._4SgWf5e5x{color:var(--primary-text);font-size:7px}._7x9syaeJx{color:var(--secondary-text);font-size:7px}.sg1SECK6x{position:relative;width:208px;height:183px;margin-top:37px;background-image:url(" + ___CSS_LOADER_URL_REPLACEMENT_4___ + ")}._5BUz1lKkx{width:40px;height:40px;position:absolute;left:27px;top:67px;display:flex;flex-direction:column;align-items:center}\n", ""]);
// Exports
exports.locals = {
	"tabletScreen": "768px",
	"smallScreen": "1100px",
	"mediumScreen": "1300px",
	"largeScreen": "1500px",
	"azure": "#006fc8",
	"cyan": "#1FAECE",
	"primaryText": "var(--primary-text)",
	"secondaryText": "var(--secondary-text)",
	"chartGridColor": "var(--ui-divider)",
	"gray10": "#dedede",
	"msDarkBlue": "#002050",
	"amberLight2": "#F7E28B",
	"violetLight2": "#CEC0EC",
	"tealLight3": "#CFECE8",
	"bannerBlue": "var(--banner-blue)",
	"spaceXXS": "4px",
	"spaceXS": "8px",
	"spaceS": "16px",
	"spaceM": "20px",
	"spaceXM": "24px",
	"spaceL": "32px",
	"spaceXL": "40px",
	"spaceXXL": "60px",
	"panelSlideDuration": "200ms",
	"panelFadeDuration": "100ms",
	"ccBannerHeight": "46px",
	"chartCyan": "var(--charts-cyan)",
	"chartMapBorders": "var(--charts-map-border)",
	"chartMapBgDefault": "var(--charts-map-bg)",
	"device-ios": "_2e8N67kqx",
	"deviceIos": "_2e8N67kqx",
	"icon-container-ios": "_6OM77VWMx",
	"iconContainerIos": "_6OM77VWMx",
	"icon-name-ios": "_5pny85yNx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"iconNameIos": "_5pny85yNx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"device-android": "_1qZe8FP0x",
	"deviceAndroid": "_1qZe8FP0x",
	"icon-container-android": "_5226wlYLx",
	"iconContainerAndroid": "_5226wlYLx",
	"notification-text-android": "_4w7kyxBfx",
	"notificationTextAndroid": "_4w7kyxBfx",
	"notification-file-android": "_46J0BXSnx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notificationFileAndroid": "_46J0BXSnx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notification-status-android": "_7lIpxyHJx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notificationStatusAndroid": "_7lIpxyHJx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"device-macos": "_2H23Xd8Ux",
	"deviceMacos": "_2H23Xd8Ux",
	"icon-container-macos": "_5GeJdZWQx",
	"iconContainerMacos": "_5GeJdZWQx",
	"notification-text-macos": "_6TXhMFnTx",
	"notificationTextMacos": "_6TXhMFnTx",
	"notification-file-macos": "_1hRDXjVjx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notificationFileMacos": "_1hRDXjVjx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notification-status-macos": "uqvcJxpAx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notificationStatusMacos": "uqvcJxpAx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"device-uwp-desktop": "_1WwMGZD2x",
	"deviceUwpDesktop": "_1WwMGZD2x",
	"icon-container-uwp-desktop": "_2Ffbn4Atx",
	"iconContainerUwpDesktop": "_2Ffbn4Atx",
	"notification-text-uwp-desktop": "_7b1wpLoQx",
	"notificationTextUwpDesktop": "_7b1wpLoQx",
	"notification-file-uwp-desktop": "_4SgWf5e5x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notificationFileUwpDesktop": "_4SgWf5e5x " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notification-status-uwp-desktop": "_7x9syaeJx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"notificationStatusUwpDesktop": "_7x9syaeJx " + ___CSS_LOADER_ICSS_IMPORT_0___.locals["ellipsize"] + "",
	"device-uwp-mobile": "sg1SECK6x",
	"deviceUwpMobile": "sg1SECK6x",
	"icon-container-uwp-mobile": "_5BUz1lKkx",
	"iconContainerUwpMobile": "_5BUz1lKkx"
};
module.exports = exports;
